"use client";
import {Button} from "@/components/ui/button";
import {useGoogleLogin} from "@react-oauth/google";
import toast from "react-hot-toast";

export function GoogleLoginButton({className, onLogin, ...props}: React.ComponentProps<"button"> & {onLogin: (data: any) => void}) {
  const googleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: async codeResponse => {
      try {
        let res = await toast.promise(
          fetch("/api/users/connect-with-google", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({...codeResponse})
          }),
          {
            loading: "Logging you in"
          }
        );
        let data = await res.json();
        if (res.ok && data.status === "success" && data.data) {
          onLogin(data.data);
          return;
        } else {
          toast.error(data?.error || data?.message || "Google login failed");
        }
      } catch (err) {
        toast.error("Network error. Please try again.");
      }
    },
    onError: errorResponse => toast.error(errorResponse?.error || "Google login error")
  });

  return (
    <Button variant="outline" className="w-full" onClick={() => googleLogin()}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="mr-2 size-4">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.42 1.46 8.36 3.41l6.24-6.24C34.33 2.7 29.52 0 24 0 14.88 0 6.99 5.7 3.43 13.8l7.36 5.72C12.78 13.12 17.98 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.1 24.5c0-1.64-.14-3.18-.38-4.68H24v9.07h12.4c-.54 2.9-2.2 5.36-4.71 7.03l7.34 5.72C43.3 37.6 46.1 31.6 46.1 24.5z" />
        <path fill="#FBBC05" d="M10.79 28.8a14.6 14.6 0 0 1 0-9.6l-7.36-5.72a23.95 23.95 0 0 0 0 21.04l7.36-5.72z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.92-2.14 15.89-5.83l-7.34-5.72c-2.04 1.38-4.65 2.2-8.55 2.2-6.02 0-11.22-3.62-13.21-8.62l-7.36 5.72C6.99 42.3 14.88 48 24 48z" />
        <path fill="none" d="M0 0h48v48H0z" />
      </svg>
      Sign in with Google
    </Button>
  );
}
